import * as types from './types';

export const pushSuccessToast = (message: string) => ({
   type: types.PUSH_TOAST,
   payload: {
      level: types.levels.SUCCESS,
      message,
   },
});

export const pushWarnToast = (message: string) => ({
   type: types.PUSH_TOAST,
   payload: {
      level: types.levels.WARN,
      message,
   },
});

export const pushErrorToast = (message = 'Something went wrong, please try again later') => ({
   type: types.PUSH_TOAST,
   payload: {
      level: types.levels.ERROR,
      message,
   },
});

export const pushInfoToast = (message: string) => ({
   type: types.PUSH_TOAST,
   payload: {
      level: types.levels.INFO,
      message,
   },
});

export const closeToast = (id: string) => ({
   type: types.CLOSE_TOAST,
   payload: id,
});
